import { startDesignDnaDemoStreamLoop } from './designDnaDemoStreamLoop.js'

/**
 * @typedef {{
 *   tid: string,
 *   pendingId: string,
 *   signal: AbortSignal,
 *   session: ReturnType<import('../streamSession.js').createAssistantStreamSession>,
 *   setMessagesByThreadId: (updater: (prev: Record<string, unknown[]>) => Record<string, unknown[]>) => void,
 * }} DesignDnaStreamCtx
 */

/** @param {DesignDnaStreamCtx} ctx */
export function runDesignDnaDemoStream(ctx) {
  startDesignDnaDemoStreamLoop(ctx)
}
